import axios from "axios";
import { API_URL } from "./index";

// eslint-disable-next-line
export default {
    GetToken() {
        return axios({
            method: "post",
            url: `${API_URL}get-token`,
            data: {
                key: 'wHjOKqH25WwOEeHphyGR',
                secret: '37m2LWciLhboNNFA6UkQ',
            },
        });
    },
    CreateHandoverWithSign(token, postIDs, name, lastname, digitalSign, note) {
        return axios({
            method: "post",
            url: `${API_URL}flow/digital-sign-handover`,
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            data: {
                postIDs,
                name,
                lastname,
                digitalSign,
                note
            },
        });
    },

    CreateTransAction(token, data) {
        console.log(data)
        return axios({
            method: "post",
            url: `${API_URL}transactions/create`,
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            data: data,
        });
    },
};
